<template>
  <div class="align-center pa-5 panel-container">
    <div class="d-flex mb-2">
      <div class="form-subtitle" v-if="Object.keys(items).length > 0">{{ title }}</div>
      <div class="form-subtitle" v-if="Object.keys(items).length == 0">{{ emptyPlaceHolder }}</div>
      <!-- <v-btn   depressed class="ml-auto" width="16" height="16">
      </v-btn>-->
      <v-img
        @click="close"
        class="close-img ml-auto"
        max-width="14"
        max-height="14"
        :src="img.close"
      ></v-img>
    </div>
    <div>

      <div v-for="(group, key) in items" :key="key">

        <div v-if="group.children != null && group.children.length > 0" class="mt-4">{{ $i18n.locale == "zh" ? group.name : group.name_en}}</div>
        <v-badge color="transparent" right overlap v-for="(item, k) in group.children" :key="k">
          <template v-slot:badge>
            <div class="selected-icon" v-if="isSelected(item)">
              <v-img :src="img.selected"></v-img>
            </div>
          </template>
          <v-chip
            @click="selectItem(item)"
            :class="{item: true, 'ma-1': true, selectedItem: isSelected(item), noSelectedItem: !isSelected(item)}"
          >{{ $i18n.locale == "zh" ? item.name : item.name_en }}</v-chip>
        </v-badge>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MGroupSelectorPanel",
  data() {
    return {
      img: {
        close: require("@/assets/img/close_img.svg"),
        selected: require("@/assets/img/selected_icon.svg")
      }
    };
  },
  props: {
    value: { type: Array },
    title: String,
    emptyPlaceHolder: String,
    on: Boolean,
    disableItem: Function,
    items: {
      type: [Object],
      default: []
    }, // [text: string, value: string]
    isEqual: Function
  },
  created: function() {
    // console.log("items", this.items);
  },

  methods: {
    isSelected(item) {
    //   return true;
      return !!this.value.find(selected => {
        if (this.isEqual) {
          return this.isEqual(item, selected);
        } else {
          return item.value == selected;
        }
      });
    },
    selectItem(item) {

      if (this.disableItem) {
        if (this.disableItem(item)) {
          return;
        }
      }
      const itemVal = item;
      let isAdd = true;

      const isEqual = function(v) {
        if (this.isEqual) {
          return this.isEqual(v, itemVal);
        } else {
          return v == itemVal;
        }
      }.bind(this);
      if (this.value.find(isEqual)) {
        const index = this.value.findIndex(isEqual);
        this.value.splice(index, 1);
        isAdd = false;
      } else {
        isAdd = true;
        this.value = [...this.value, item];
      }

      this.$emit("input", this.value);
      this.$emit("onSeleteChange", { value: itemVal, isAdd });
    },

    close() {
      this.$emit("onClose");
    }
    // updateValue: function(value) {
    // }
  }
};
</script>

<style scoped>
@import "../../assets/css/common.css";

.panel-container {
  width: 477px;
}
.item {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-radius: 3px !important;
  border-width: 1px !important;
  border-style: solid !important;
  cursor: pointer;
}

.close-img {
  cursor: pointer;
}
.selected-icon {
  height: 12px;
  width: 12px;
}
.selectedItem {
  background-color: #dbebff !important;
  border-color: #328dff !important;
  color: #328dff !important;
}

.noSelectedItem {
  background-color: white !important;
  border-color: #666666 !important;
  color: #666666 !important;
}
</style>




